import {getDateTimeStr}                     from '../../lib/iprs-react-library/src/index.js';

class Address {
    
    line1           = null
    line2           = null
    town            = null
    county          = null
    postcode        = null
    country         = null
    
    constructor(data = {}){
        
        const { Address1:     line1         = null,
                Address2:     line2         = null,
                Town:         town          = null,
                County:       county        = null,
                Postcode:     postcode      = null,
                Country:      country       = null
        }                                   = data
        
        this.line1                          = line1
        this.line2                          = line2
        this.town                           = town
        this.county                         = county
        this.postcode                       = postcode
        this.country                        = country
    }
}

class Patient {
    
    caseID          = null
    clientName      = null
    internalCaseID  = 0
    personalTitle   = null
    firstName       = null
    lastName        = null
    birthDate       = null
    gender          = null
    referralDate    = null
    
    addresses       = []
    
    confirmed       = false;
    
    constructor( data ){
        
        if( data instanceof Patient ){
            this.caseID =           data.caseID
            this.clientName       = data.clientName;  
            this.internalCaseID =   data.internalCaseID
            this.personalTitle =    data.personalTitle
            this.firstName =        data.firstName
            this.lastName =         data.lastName
            this.birthDate =        data.birthDate
            this.gender =           data.gender
            this.referralDate =     data.referralDate
            this.addresses      =   data.addresses
            this.confirmed      =   data.confirmed;
        }else if (data) {
            const {
                CaseID:             caseID          = null,
                ClientName:         clientName      = null,
                PersonalTitle:      personalTitle   = null,
                FirstName:          firstName       = null,
                LastName:           lastName        = null,
                BirthDate:          birthDate       = null,
                Gender:             gender          = null,
                pkCaseID:           internalCaseID  = 0,
                ReferralDate:       referralDate    = null,
                PostalAddressList:  addresses       = []
            } = data || {};
            
            this.caseID =           caseID;
            this.clientName      =  clientName;
            this.personalTitle =    personalTitle
            this.firstName =        firstName
            this.lastName =         lastName
            this.birthDate =        birthDate
            this.gender =           gender
            this.internalCaseID =   internalCaseID
            this.referralDate     = referralDate
            
            this.addresses = addresses.map( a => new Address( a ) )
        }
    }
    
    /**
     * Determin if this patient has a recorded address
     * @returns {Patient.addresses.length}
     */
    hasAddress(){
        return this.addresses.length
    }
    
    /**
     * Returns the first address
     */
    getAddress(){
        if( this.hasAddress() ){
            return this.addresses[0]
        }else{
            return null
        }
    }
}

class AppointmentType {
    
    appointmentTypeID               = 0;
    description                     = null;
    defaultLength                   = 0;
    imageURL                        = null;
    title                           = null;
    
    constructor( data ){
        
        if( Number.isInteger( data ) && data ){
            this.appointmentTypeID = data
        }else if ( data instanceof AppointmentType ){
            
            this.appointmentTypeID  = data.appointmentTypeID
            this.description        = data.description
            this.defaultLength      = data.defaultLength
            this.imageURL           = data.imageURL
            this.title              = data.title
            
        }else{
            
            let appType
            if ( !data.description && data.appointmentTypes && data.appointmentTypeID ){
                //console.log('data.appointmentTypes', data.appointmentTypes )
                const appTypes = data.appointmentTypes.filter( t => t.AppointmentTypeID === data.appointmentTypeID )
                //console.log('appTypes', appTypes )
                appType = appTypes[0];
                //console.log('appTypes', appType )
            }else{
                appType = data
            }
            
            const {
                AppointmentTypeID                           = 0,
                appointmentTypeID                           = 0,
                Description:            description         = null,
                DefaultLength:          defaultLength       = 0,
                ImageURL:               imageURL            = null,
                Title:                  title               = null
            }                                                    =   appType
            this.appointmentTypeID          = appointmentTypeID? appointmentTypeID: AppointmentTypeID;
            this.description                = description
            this.defaultLength              = defaultLength
            this.imageURL                   = imageURL
            this.title                      = title;
            
        }
    }
}

class Clinician {
    
    name            = null
    partyID         = 0;
    teams           = []; // the teams of which the clinician is a member
    
    constructor( data ){
        
        if ( data instanceof Clinician ){
            
            this.name       = data.name;
            this.partyID    = data.partyID;
            this.teams      = data.teams;
        }else if ( data ){
            
            const { Name = null, name = null, PartyID = null, partyID = null,
                TeamIDs} = data
            
            this.name       = name?     name:       Name;
            this.partyID    = partyID?  partyID:    PartyID;
            this.teams      = Array.isArray( TeamIDs )? TeamIDs: this.teams;
        }
        
    }
}

class Client {
    
    name              = ''
    
    constructor( data = {} ){
         
        if ( data instanceof Client ){
            this.name = data.name
        }else{
            
            this.name = data.name? data.name: this.name
        }
    }
}

//const epoch = () => new Date('1970-01-01')

/** 
 * This class is an attempt to formalise the data that exist on a booking.
 * One problem has been that the API uses keys with a leading captital whereas
 * local variables have lower case and the fileds in the calendar API, such as
 * start and end are lower case. Also we have som instances of FinishTime as well
 * as well as end in the calendar API.
 * */
class BookingData {
    
    patient                 = new Patient()
    
    /* descriptive text for the booking. Not forpatient record */
    description             = null
    
    client                  = new Client()
    
    clinician               = new Clinician();
    appointmentType         = null
    availableAppTypes       = null;
    
    start                   = null
    end                     = null
    rotaID                  = 0
    
    bookingID               = 0;
    
    confirmed               = false;
    
    #rescheduling           = false;
    #rescheduleID           = 0;

    isVisual                = false;

    earliestDateTimeOffered = null;
    apptTimeExplanation     = null;
    isApptWithin5Days       = false;
    

    getStartString(){ 
        return this.start? getDateTimeStr( this.start ): null
    }
    
    getEndString(){ 
        return this.end? getDateTimeStr( this.end ): null
    }
    
    hasAppoinmnetType(){
        return this.appointmentType? true: false
    }
    
    getAppoinmnetTypeID(){
        return this.appointmentType? this.appointmentType.appointmentTypeID: 0
    }
    
    hasDescription(){
        return null != this.description;
    }
    
    setRescheduling(value){
        this.#rescheduling = value;
    }
    
    isRescheduling(){
        return this.#rescheduling;
    }
    
    setRescheduleID(id){
        this.#rescheduleID = id;
    }
    
    getRescheduleID(){
        return this.#rescheduleID;
    }
    
    /**
     * Load data from an API call to getBooking. This currently doesn't return 
     * the appointment type so we need to look that up from the stored set of 
     * types
     * @param {type} apiResult
     * @param {type} appTypes
     * @returns {undefined}
     */
    loadFromAPI( apiResult, appTypes ){
        
        // cannot change a bookingID
        const bookingIDSave = this.bookingID;
        this.setData( apiResult );
        if(bookingIDSave){
            this.bookingID = bookingIDSave;
        }
        
        if (!this.appointmentType){
            const appType = appTypes.filter( t => t.AppointmentTypeID === apiResult.AppointmentTypeID )[0];
            this.appointmentType = new AppointmentType( appType );
        }
    }
    
    setPatientData( data ){
        
        this.patient        = new Patient( data )
        
        const { ClientName: name = '' } = data 
        
        // will only take out the client data
        this.client         = new Client( { name } ) 
    }
    
    hasPatientData(){
        if(this.patient.internalCaseID){
            return true;
        }else{
            return false;
        }
    }
    
    // have we confirmed the patient data (pressed OK)
    hasPatientConfirmed(){
        if(this.patient.confirmed){
            return true;
        }else{
            return false;
        }
    }
    
    constructor( data ){
        this.setData( data )
    }
    
    setData( data ){
        
        if( data instanceof BookingData ){
            
            this.patient         = data.patient?    data.patient:   this.patient
            this.description     = data.description? data.description: this.description;
            this.client          = data.client?     data.client:   this.client
            this.clinician       = data.clinician?  new Clinician( data.clinician ): this.clinician
            if( Array.isArray( data.availableAppTypes ) ){
                this.availableAppTypes = data.availableAppTypes;
            }
            this.appointmentType = data.appointmentType;
            
            this.start           = data.start?      data.start: this.start
            this.end             = data.end?        data.end:   this.end
    
            this.rotaID          = data.rotaID?     data.rotaID: this.rotaID
    
            this.bookingID       = data.bookingID?  data.bookingID: this.bookingID
            this.confirmed       = data.confirmed;
            this.setRescheduling( data.isRescheduling() );
            this.setRescheduleID(data.getRescheduleID());

            this.isVisual        = data.isVisual;
            this.earliestDateTimeOffered = data.earliestDateTimeOffered;
            this.apptTimeExplanation     = data.apptTimeExplanation;
            this.isApptWithin5Days       = data.isApptWithin5Days;
            
        }else if( typeof data !== 'undefined' && data ) {
            const {
                Confirmed:          confirmed         = false,
                BookingID:          booking           = 0,
                Patient:            patientS =          null,
                Description:        description       = null,
                PatientData:        patientL  =         null,
                ClientName:         clientName =        null,
                PartyID                             =   0,
                partyID                             =   0,
                partyName                           =   0,  
                Clinician:          clinician       =   null,
                AppointmentTypeID:  appTypeID       =   null,
                StartTime:          startTime       =   null,
                Start                               =   null,
                start                               =   null,
                Finish:             fin             =   null,
                FinishTime:         finTime         =   null,
                end                                 =  null, 
                AppointmentType:    appointmentType =   null,
                rotaID                              =   0,
                isVisual                            =   null,
                Within5WorkingDays: isApptWithin5Days = false,
                AppointmentTimeReason: apptTimeExplanation = null,
            } = data;
            
            const patient   = patientS? new Patient( patientS ): ( patientL? new Patient( patientL ): new Patient( this.patient ) );
            
            if( appointmentType ){
                this.appointmentType = new AppointmentType( appointmentType )
            }else if ( appTypeID ){
                this.appointmentType = new AppointmentType( appTypeID )
            }
            
            this.patient                 = new Patient( patient )
            
            this.description             = description? description: this.description;
            
            this.clientName              = clientName? clientName: this.clientName
            this.clinician               = clinician? new Clinician( clinician ): new Clinician( this.clinician )
    
            this.rotaID                  = rotaID? rotaID: this.rotaID
            if( partyID || PartyID) {
                this.clinician.partyID = ( partyID? partyID: PartyID )
                this.clinician.name = 'Clinician (' + this.clinician.partyID + ')'
            }
            if(partyName){
                this.clinician.name = partyName
            }
            const st = startTime?   startTime:  (Start?   Start:   start);
            const ed = fin?         fin:        (finTime? finTime: end);
    
            this.start                   = st? new Date( st ): this.start 
            this.end                     = ed? new Date( ed ): this.end
    
            this.bookingID               = booking? booking: this.booking
            this.confirmed               = confirmed;
            
            if( data.Clinician ){
                this.clinician = new Clinician( data.Clinician );
            }
            
            if( data.patient ){
                this.patient = new Patient( data.patient );
            }
            
            if( Array.isArray( data.availableAppTypes ) ){
                this.availableAppTypes = data.availableAppTypes;
            }

            this.isVisual = null != isVisual ? (true === isVisual) : this.isVisual;

            this.isApptWithin5Days       = isApptWithin5Days;
            this.apptTimeExplanation     = apptTimeExplanation;
        }
        
        
    }
    
    
}

export default BookingData